import styled from 'styled-components';

export const InfoText = styled.div`
    margin: 1rem;
    font-size: 1rem;
    font-weight: 500;
    .icon{
        padding: 0 5px 0;
    }
`;
